// Smart Sash Admin Panel - Notification Container Component
// Container for displaying toast notifications

import { useUIStore } from '@/store';
import React from 'react';
import { NotificationToast } from './NotificationToast';

/**
 * Notification container positioned in top-right corner
 */
export const NotificationContainer: React.FC = () => {
  const { notifications, removeNotification } = useUIStore();

  return (
    <div className="position-fixed top-0 end-0 p-3" style={{ zIndex: 9999, maxWidth: '400px' }}>
      {notifications.map((notification) => (
        <NotificationToast
          key={notification.id}
          id={notification.id}
          type={notification.type}
          title={notification.type.charAt(0).toUpperCase() + notification.type.slice(1)}
          message={notification.message}
          duration={notification.duration}
          onDismiss={removeNotification}
        />
      ))}
    </div>
  );
};

export default NotificationContainer;
